/** The two posting screens - Sales Invoice Posting and Credit Note Posting (invoice posting screen, Nov 2026). */
export enum PostingDocuments {
  salesInvoices = 'SalesInvoices',
  creditNotes = 'CreditNotes',
}
